<template>
    <div class="page-layout new-background" >
		<div class="d-flex flex-direction-mob py-4 px-4">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center mr-2">
                    <router-link :to="{ path: $routerHistory.previous().path }">
                        <el-tooltip v-if="$routerHistory.hasPrevious()" class="item pull-left" effect="dark" content="Click to Go Back" placement="top">
                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/previous.svg" class="mr-2">
                        </el-tooltip>
                    </router-link>
                    <router-link :to="{ path: $routerHistory.next().path }">
                        <el-tooltip v-if="$routerHistory.hasForward()" class="item pull-left" effect="dark" content="Click to Go Forward"
                            placement="top">
                            <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/next.svg">
                        </el-tooltip>
                    </router-link>
                </div>
                <div class="flex-direction-mob-search-width">
                    <div class="mob-device-search position-relative">
                        <div class="position-relative pointer" @click="showSearchMobActive">
                            <div class="search-icon-mob d-flex align-items-center justify-content-center">
                                <i class="icon icon-magnify"></i>
                            </div>
                        </div>
                        <div class="mob-device-search-input" :class="{'mob-device-search-input-active': search_mob_active}">
                            <div class="w-100 position-relative">
                                <span>
                                    <i class="icon icon-magnify align-position fs-18"></i>
                                </span>
                                <span @click="showSearchMobActive" class="pointer">
                                    <i class="icon icon-close fs-18 position-absolute text-dark" style="right: 5px;top: 5px;"></i>
                                </span>
                                <input type="text" class="search_input w-100" v-model="search_key" @input="searchData" placeholder="Search by Facility Name" style="padding-right: 30px !important;" />
                            </div>
                        </div>
                    </div>
                    <div class="w-100 position-relative desktop-device-search pr-2">
                        <span>
                            <i class="icon icon-magnify align-position fs-18"></i>
                        </span>
                        <input type="text" class="search_input w-100" v-model="search_key" @input="searchData" placeholder="Search by Facility Name" />
                    </div>
                </div>
                <!-- <h1 class="pointer qr-code-btn fs-14" @click="showScanQrCode">
                    <img class="qr-code-image" width="40" height="40" src="https://cdn.digicollect.com/cdn/facility/qr_code_new_image.svg" alt="QR code" />
                </h1> -->
            </div>
            <div class="d-flex align-items-center flex-direction-mob-contact-list">
                <button type="button" class="btn-new-call text-secondary d-flex align-items-center fs-14 pointer" @click="showContactsListModal">
                    <img src="https://cdn.digicollect.com/cdn/facility/incoming_calls_icon.svg" alt="call" />
                    <span class="ml-2">
                        Emergency Contact List
                    </span>
                </button>
            </div>
		</div>
        <div class="page-layout blank">
            <div class="pb-10" style="min-height: 600px;">
                <div class="vendor-list py-3">
                    <div class="d-flex flex-wrap align-items-center justify-content-between mb-3 ml-4">
                        <div class="text-new-blue" style="font-size: 15px;">
                            <span class="fw-500 " style="text-transform:capitalize;">
                                <span v-if="$route.path == '/pm/ticketdetails'">
                                    PM
                                </span>
                                Event Logs </span>  |  {{total}}  Total
                        </div>
                    </div>
                    <div class="table-content mb-3" style="overflow-x: auto !important;">
                        <table class="table table-content-data table-responsive">
                            <thead>
                                <tr>
                                    <th class="whiteSpace w-1">
                                        <span class="cursor-th" >
                                        <!-- <span v-on:click="setPasskey('facility_name')" class="cursor-th" > -->
                                            Facility Name
                                            <!-- <span v-if="passed_key.key=='facility_name' && passed_key.value== -1" :class="{'hide-arrow': passed_key.key != 'facility_name'}" class="sorting-icon">
                                                <i class="icon-arrow-down text-white" style="font-size: 16px !important;"></i>
                                            </span>
                                            <span style="font-size: 16px !important;" v-else :class="{'hide-arrow': passed_key.key != 'facility_name'}" class="sorting-icon">
                                                <i class="icon-arrow-up text-white" style="font-size: 16px !important;"></i>
                                            </span> -->
                                        </span>
                                    </th>
                                    <!-- <th class="whiteSpace w-1">
                                        <span v-on:click="setPasskey('department')" class="cursor-th" >
                                            Department
                                        </span>
                                    </th> -->
                                    <th class="whiteSpace w-1">
                                        <span class="cursor-th" >
                                            Comments
                                        </span>
                                    </th>
                                    <!-- <th class="whiteSpace w-1">
                                        <span class="cursor-th" >
                                            Reason For Concern
                                        </span>
                                    </th> -->
                                    <th class="whiteSpace w-1">
                                        <span class="cursor-th" >
                                            Assigned By
                                        </span>
                                    </th>
                                    <th class="whiteSpace w-1">
                                        <span class="cursor-th" >
                                            Date
                                        </span>
                                    </th>
                                    <th class="whiteSpace w-1">
                                        <span class="cursor-th" >
                                            Time
                                        </span>
                                    </th>
                                    <!-- <th class="whiteSpace w-1">
                                        <span class="cursor-th" >
                                            Priority
                                        </span>
                                    </th> -->
                                    <th class="whiteSpace w-1">
                                        <span class="cursor-th" >
                                            Location
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="ajax_call_in_progress" class="text-center font-weight-bold" style="background-color: #eff9fd !important;">
                                    <td colspan="8">
                                        <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center"/>
                                    </td>
                                </tr>
                                <tr v-if="!ajax_call_in_progress && list_data.length == 0" class="text-center font-weight-bold ht-100px">
                                    <td colspan="8">No Data Found</td>
                                </tr>
                                <tr v-else v-for="(data, index) in list_data" :key="index+'iddd'" @click="goToDetailsView(data._id)">
                                    <td class="whiteSpace w-1 pointer">
                                        <span class="text-blue-new pointer">{{data.facility_name || "-"}}</span>
                                    </td>
                                    <!-- <td class="whiteSpace w-1 pointer">
                                        {{data.department || "-"}}
                                    </td> -->
                                    <!-- <td class="whiteSpace w-1 pointer">
                                        {{data.reason_for_concern || "-"}}
                                    </td> -->
                                    <td class="whiteSpace w-1 pointer">
                                        <span :title="data.comments || '-'" class="d-block w-100 table-large-text">{{data.comments || "-"}}</span>
                                    </td>
                                    <td class="whiteSpace w-1 pointer">
                                        {{data.assigned_by || "-"}}
                                    </td>
                                    <td class="whiteSpace w-1 pointer">
                                        {{data.date_time.date || "-"}}
                                    </td>
                                    <td v-if="data.date_time.time" class="whiteSpace w-1 pointer">
                                        {{convertTime24To12(data.date_time.time)}}
                                    </td>
                                    <td v-else class="whiteSpace w-1 pointer">
                                        -
                                    </td>
                                    <!-- <td class="whiteSpace w-1 pointer">
                                        <button type="button" class="btn btn-danger fs-14 text-capitalize" style="border-radius: 18px !important" :class="{'high-priority':data.priority == 'High', 'medium-priority':data.priority == 'Medium', 'low-priority':data.priority == 'Low'}">
                                            {{data.priority}}
                                        </button>
                                    </td> -->
                                    <td class="whiteSpace w-1 pointer">
                                        <span :title="data.location || '-'" class="d-block w-100 table-large-text">{{data.location || "-"}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="d-flex align-items-center font-weight-bold mt-2 justify-content-end pr-2" v-if="total > 0">
                        <multiselect class="diginew-multiselect dd-ht multiple-select-arrow-hide"
                            :options="pageLimit" :close-on-select="true" v-model.number="limit"
                            @search-change="getListViewData"
                            open-direction="top" :show-labels="false" placeholder=""
                            style="width: 5.3em !important;padding-right: 10px!important;"></multiselect>
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey.svg"
                            style="margin-left: -35px;">
                        <span class="page-info pr-2 pl-6 fw-500"
                            style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 12px;">Per page</span>
                        <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                            <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                                <i class="icon-chevron-double-left"></i>
                            </el-tooltip>
                        </button>
                        <button @click="previousPage()" :disabled="skip == 0" class="pagination-list mt-1 ml-2 pointer">
                            <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                                <i class="icon icon-chevron-left"></i>
                            </el-tooltip>
                        </button>
                        <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                        <button @click="nextPage()" :disabled="skip_temp >= total" class="pagination-list mt-1 mr-2 pointer">
                            <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                                <i class="icon icon-chevron-right"></i>
                            </el-tooltip>
                        </button>
                        <button @click="lastPage()" class="mt-1 pointer pagination-list" :disabled ="temp_total == total">
                            <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                                <i class="icon-chevron-double-right"></i>
                            </el-tooltip>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <scan-qr-code v-if="scan_qr_code_modal" @hideQrCode="hideScanQrCode" modal_name="Scan-Qr-Code-Modal"></scan-qr-code>
        <emergency-contact-list v-if="contacts_list_modal" @hideModal="hideContactsListModal" modal_name="Contacts-List-Modal"></emergency-contact-list>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import facility_mgmt from '../mixins/facility_mgmt'
import { SweetModal } from 'sweet-modal-vue';
import time_utils from '../mixins/time_utils';
const ScanQrCode = () => import("./ScanQrCode")
const EmergencyContactList = () => import("./EmergencyContactList")
export default {
    mixins: [facility_mgmt, time_utils],
    components:{
        ScanQrCode,
        EmergencyContactList,
        SweetModal
    },
    data(){
        return{
            success_msg:'',
            warning_msg:'',
            scan_qr_code_modal: false,
            contacts_list_modal: false,
            skip:0,
            limit:10,
            total:0,
            temp_total:0,
            search_key:'',
            pageLimit: [],
            skip_temp: 0,
            count:0,
            ajax_call_in_progress: false,
            passed_key: {
                key: 'facility_name',
                value: -1
            },
            list_data: [],
            search_mob_active: false
        }
    },
    methods:{
        hideScanQrCode() {
            this.scan_qr_code_modal = false;
            setTimeout(() => {
                this.$modal.hide('Scan-Qr-Code-Modal');
            }, 500);
        },
        showSearchMobActive() {
            this.search_mob_active = !this.search_mob_active;
        },
        showScanQrCode() {
            this.scan_qr_code_modal = true;
            setTimeout(() => {
                this.$modal.show('Scan-Qr-Code-Modal');
            }, 500);
        },
        showContactsListModal() {
            this.contacts_list_modal = true;
            setTimeout(() => {
                this.$modal.show('Contacts-List-Modal');
            }, 500);
        },
        hideContactsListModal() {
            this.contacts_list_modal = false;
            setTimeout(() => {
                this.$modal.hide('Contacts-List-Modal');
            }, 500);
        },
        searchData() {
            this.temp_total = 0
            this.skip = 0
            this.limit = 10
            this.list_data = []
            this.getListViewData();
        },
        setPasskey: function (newKey) {
            this.$set(this.passed_key, 'key', newKey)
            var value = this.passed_key.value == -1 ? 1 : -1
            this.$set(this.passed_key, 'value', value)
            this.getListViewData()
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = 10
            this.list_data = []
            this.getListViewData()
        },
        lastPage(){
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.getListViewData();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.getListViewData();
        },
        previousPage() {
            this.skip_temp = 0
            this.temp_total = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.getListViewData();
        },
        async getListViewData(){
            this.list_data = [];
            this.ajax_call_in_progress = true;
            try {
                let params = {
                    skip: this.skip,
                    limit: this.limit == null ? 10 : this.limit,
                    search_key: this.search_key.trim(),
                };
                let response = await this.listSecurityConcern(params);
                this.list_data = response.response.security_details;
                this.total = response.response.count;
                this.ajax_call_in_progress = false;
            }
            catch(error){
                this.warning_msg = error;
                this.$refs.warning_modal.open();
                this.ajax_call_in_progress = false;
            }
        },
        async goToDetailsView(id) {
            this.$router.push('/facilitymanagement/securityconcern/view/' + id);
        }
    },
    mounted(){
        this.getListViewData()
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
    },
    computed: {
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
    },
    destroyed(){

    },
    watch: {
        limit: function(){
            this.getListViewData();
        }
    },
}
</script>
<style scoped>
    .text-new-blue{
        color: #00448b;

    }
    .new-background{
        background:#f0ddb7 !important;
        border-radius: 10px;
    }
    .search_input {
        padding: 8px 9.4px 6.5px 33.4px;
        border-radius: 24px;
        background-color: #fff;
    }
    .qr-code-btn {
        margin: 0 8px 0 10px;
    }
    .qr-code-image {
        overflow: hidden;
        white-space: nowrap;
    }
    .btn-new-call {
        padding: 6.5px 10px;
        border-radius: 8px;
        border: solid 0.5px #0475f3;
        width: -webkit-max-content;
        width: -moz-max-content;
        width: max-content;
        background-color: #fff;
        outline: 0 none !important;
    }
    .align-position {
        position: absolute;
        left: 10px;
        top: 7px;
        color: rgba(103, 103, 103, 0.84);
    }
    .main-content {
        background-color: #fff;
        padding: 16.4px 0 10.2px;
        border-radius: 6px;
    }
    .table-large-text{
        max-width: 280px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .mob-device-search {
        display: none;
    }
    .desktop-device-search {
        display: block;
    }
    .search-icon-mob {
        width: 35px;
        height: 35px;
        background-color: #fff;
        border-radius: 50%;
    }
    .mob-device-search-input {
        display: none;
        position: fixed;
        z-index: 8;
        left: 10px;
        right: 10px;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
        border-radius: 18px;
    }
    .mob-device-search-input-active {
        display: block;
    }
    .flex-direction-mob {
        flex-direction: column;
        align-items: flex-start;
    }
    .flex-direction-mob-search-width {
        width: auto;
    }
    .flex-direction-mob-contact-list {
        padding-top: 15px;
    }
    .ht-100px{
        height: 100px;
    }
    @media screen and (min-width: 400px) {
        .flex-direction-mob {
            flex-direction: row;
            align-items: center;
        }
        .flex-direction-mob-search-width {
            width: 100%;
        }
        .flex-direction-mob-contact-list {
            padding-top: 0;
        }
    }
    @media screen and (max-width: 576px) {
        .desktop-device-search {
            display: none;
        }
        .mob-device-search {
            display: block;
        }
    }
</style>